import { Container, Grid, Link } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import Menu from "../../Components/Menu/MainMenu";

import telegram from "../../images/telegram.png"
import medium from "../../images/medium.png"
import twitter from "../../images/twitter.png"
import instagram from "../../images/instagram.png"
import discord from "../../images/discord.png"
import gitbook from "../../images/gitbook.png"
import tiktok from "../../images/tiktok.png"
import headerImg from "../../images/headerImg.png"

const Header = () => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <div className="MS---Header">
            <Menu />
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItem="center"
                >
                    <Grid 
                        xs={12}
                        sm={6}
                        className="pt-5"
                        data-aos="zoom-in-up"
                    >
                        <h6 className="MS---sectionSubheading mb-0">STEP INTO THE METAVERSE!</h6>
                        <h1 className="d-inline-block text-left" style={{marginLeft:'-8px'}}>
                            <span className="blue">
                                BUY. PLAY.
                            </span>
                            <span className="pink d-block mt-2">EARN.</span>
                        </h1>
                        <p className="mt-4 mb-3" style={{maxWidth: 500}}>
                            MetaSnooker is a blockchain powered Play-to-Earn game that provides players with a great opportunity to win tokens by competing against other players online.
                        </p>
                        <a href="/dashboard"
                            className="MS---Neon--Button btn d-inline-block mt-4 mr-3"
                            data-aos="zoom-in"
                        >
                            Dashboard
                        </a>
                        <a href="https://game.metasnooker.io/"
                            target="blank"
                            className="MS---Neon--Button btn d-inline-block mt-4 mr-3"
                            data-aos="zoom-in"
                        >
                            Play and Earn
                        </a>
                        <a href="https://t.me/MetaSnooker"
                            target="blank"
                            className="MS---Neon--Button btn d-none d-sm-inline-block mt-4"
                            data-aos="zoom-in"
                        >
                            Join us
                        </a>
                        <div className="MS---socialMedia mt-5 d-sm-none"> 
                            <Link href="https://t.me/MetaSnooker" className="d-inline-block mr-3" target="_blank">
                                <img src={telegram} className="img-fluid" />
                            </Link>
                            <Link href="https://metasnooker.medium.com" className="d-inline-block mr-3" target="_blank">
                                <img src={medium} className="img-fluid" />
                            </Link>
                            <Link href="https://twitter.com/Snooker_Meta" className="d-inline-block mr-3" target="_blank">
                                <img src={twitter} className="img-fluid" />
                            </Link>
                            <Link href="https://www.instagram.com/meta.snooker" className="d-inline-block mr-3" target="_blank">
                                <img src={instagram} className="img-fluid" />
                            </Link>
                            {/* <Link href="https://discord.com/invite/8dPAQC3s" className="d-inline-block mb-3" target="_blank">
                                <img src={discord} className="img-fluid" />
                            </Link> */}
                            <Link href="https://docs.metasnooker.io/tokenomics" className="d-inline-block mr-3" target="_blank">
                                <img src={gitbook} className="img-fluid" />
                            </Link>
                            <Link href="http://tiktok.com/@metasnooker" className="d-inline-block" target="_blank">
                                <img src={tiktok} className="img-fluid" />
                            </Link>
                        </div>
                    </Grid>
                    <Grid 
                        xs={12}
                        sm={6}
                        className="text-center text-md-right align-self-center mt-4 pl-4"
                        data-aos="zoom-in-down"
                    >
                        <img 
                            src={headerImg} 
                            className="img-fluid w-100" 
                            style={{maxWidth: 550}} 
                        />
                        
                        
                    </Grid>
                </Grid>
            </Container>
            <div className="MS---socialMedia left d-none d-sm-flex"> 
                            <Link href="https://t.me/MetaSnooker" className="d-block mb-3" target="_blank">
                                <img src={telegram} className="img-fluid" />
                            </Link>
                            <Link href="https://metasnooker.medium.com" className="d-block mb-3" target="_blank">
                                <img src={medium} className="img-fluid" />
                            </Link>
                            <Link href="https://twitter.com/Snooker_Meta" className="d-block mb-3" target="_blank">
                                <img src={twitter} className="img-fluid" />
                            </Link>
                            <Link href="https://www.instagram.com/meta.snooker" className="d-block mb-3" target="_blank">
                                <img src={instagram} className="img-fluid" />
                            </Link>
                            {/* <Link href="https://discord.com/invite/8dPAQC3s" className="d-inline-block mb-3" target="_blank">
                                <img src={discord} className="img-fluid" />
                            </Link> */}
                            <Link href="https://docs.metasnooker.io/tokenomics" className="d-inline-block mb-3" target="_blank">
                                <img src={gitbook} className="img-fluid" />
                            </Link>
                            <Link href="http://tiktok.com/@metasnooker" className="d-inline-block mb-3" target="_blank">
                                <img src={tiktok} className="img-fluid" />
                            </Link>
                        </div>
        </div>
    );
}

export default Header;